// Used as a placeholder, i.e. for the homepage body
app.controller('general', function () {});
